import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import BuyPremiumModal from '../neoverv/components/Module/General/CustomModal/BuyPremiumModal';
import { getSubscriptionPartner } from '../helpers/partners';
import { isPrepaidSubscription } from '../helpers/subscriptionBilling';

const ADD_ONS = {
  property: 'Zusätzliche Mietobjekte',
  storage: 'Zusätzlichen Speicherplatz',
  aiCredits: 'Zusätzliches KI-Guthaben',
  postage: 'Portoguthaben',
};

export const PAYMENT_DETAILS_ROUTE = '/profile/paymentDetails';

// "Zahlungsmittel", as on the payment details page these texts lead to.
export const PAYMENT_METHOD_REQUIRED_HEADING = 'Zahlungsmittel hinterlegen';

// The opening line of every add-on text for a prepaid plan, naming the partner who sold it.
// Null for a plan hellohousing bills itself.
export const getPrepaidPlanText = (currentSubscription) => {
  const partner = getSubscriptionPartner(currentSubscription);
  if (partner) {
    return `Ihr Abonnement ist über ${partner.name} vorausbezahlt.`;
  }
  return isPrepaidSubscription(currentSubscription) ? 'Ihr Abonnement ist vorausbezahlt.' : null;
};

// Why a payment method is needed for an add-on (`addOn`: a key of ADD_ONS). A prepaid plan was
// paid in the partner's shop, so hellohousing has nothing to charge yet; every other plan is told
// the add-on comes on top of it.
export const getPaymentMethodRequiredText = (currentSubscription, addOn) => {
  const prepaidPlanText = getPrepaidPlanText(currentSubscription);
  if (prepaidPlanText) {
    return `${prepaidPlanText} ${ADD_ONS[addOn]} rechnet hellohousing direkt mit Ihnen ab. Bitte hinterlegen Sie dafür ein Zahlungsmittel.`;
  }
  return `${ADD_ONS[addOn]} rechnet hellohousing zusätzlich zu Ihrem Abonnement ab. Bitte hinterlegen Sie dafür ein Zahlungsmittel.`;
};

// Asked before an add-on is booked for an account without an authorized payment mandate (#2357,
// see requiresPaymentMethodForAddOns).
// Leads to the payment details page with the payment method selection open (PaymentDetails reads
// `openPaymentMethodSelection`); Mollie returns there after the authorization, as it does for every
// payment method change. `onNavigate` lets a dialog this is shown over close itself on the way.
const PaymentMethodRequiredModal = ({ open, onClose, addOn, onNavigate }) => {
  const history = useHistory();
  const currentSubscription = useSelector((state) => state.generalReducer.currentSubscription);
  return (
    <BuyPremiumModal
      open={Boolean(open)}
      heading={PAYMENT_METHOD_REQUIRED_HEADING}
      text={
        <span style={{ fontSize: '15px', color: 'rgb(19, 19, 92)', fontWeight: '400', textAlign: 'center', width: '350px' }}>
          {getPaymentMethodRequiredText(currentSubscription, addOn)}
        </span>
      }
      buttonText={PAYMENT_METHOD_REQUIRED_HEADING}
      onClick={() => {
        onClose();
        onNavigate?.();
        history.push(PAYMENT_DETAILS_ROUTE, { openPaymentMethodSelection: true });
      }}
      onCancel={onClose}
    />
  );
};

export default PaymentMethodRequiredModal;
